import type { Filters, PathLookupDecisionEvent } from '@ipfabric/utils';

const getFilterAttribute = (
  key: string,
  operator: string,
  value?: string | number | null,
): Filters | undefined => {
  if (value === undefined) {
    return undefined;
  }
  if (value === '' || value === null) {
    return { [key]: ['empty', true] };
  }
  return { [key]: [operator, value] };
};

export const getPathInspectorTableFilters = (
  event: PathLookupDecisionEvent,
): Filters | undefined => {
  if (event.table === undefined || event.filter === undefined) {
    return undefined;
  }
  switch (event.table) {
    case 'vRoute': {
      return {
        ...getFilterAttribute('network', 'ip', event.filter.prefix),
        ...getFilterAttribute('prefix', 'eq', event.filter.mask),
        ...getFilterAttribute('vrf', 'eq', event.filter.vrf),
      };
    }
    case 'vRouteIpv6': {
      return {
        ...getFilterAttribute('network', 'ip', event.filter.prefix),
        ...getFilterAttribute('prefix', 'eq', event.filter.mask),
        ...getFilterAttribute('vrf', 'eq', event.filter.vrf),
      };
    }
    case 'vArp': {
      return {
        ...getFilterAttribute('ip', 'like', event.filter.ip),
        ...getFilterAttribute('vrf', 'eq', event.filter.vrf),
      };
    }
    case 'vNeighborDiscovery': {
      return {
        ...getFilterAttribute('ipv6', 'like', event.filter.ip),
        ...getFilterAttribute('vrf', 'eq', event.filter.vrf),
      };
    }
    case 'vMac': {
      return {
        ...getFilterAttribute('mac', 'eq', event.filter.mac),
        ...getFilterAttribute('vlan', 'eq', event.filter.vlanNum),
        ...getFilterAttribute('spbmISid', 'eq', event.filter.iSid),
      };
    }
    case 'vSpbmBMac': {
      return {
        ...getFilterAttribute('destinationBmac', 'eq', event.filter.bMac),
        ...getFilterAttribute('backboneVlan', 'eq', event.filter.bVlan),
      };
    }
    case 'vSpbmISid': {
      return {
        ...getFilterAttribute('serviceId', 'eq', event.filter.iSid),
        ...getFilterAttribute('nodeSystemId', 'eq', event.filter.bMac),
        // pins the link to this device's own (local) entry — see the finder;
        // without it the device-view scope leaks in every node that learned
        // the service advertised by this device.
        ...getFilterAttribute('entryOrigin', 'eq', event.filter.entryOrigin),
      };
    }
    case 'vMulticastRoute': {
      return {
        ...getFilterAttribute('groupNet', 'ip', event.filter.groupIp),
        ...getFilterAttribute('sourceNet', 'ip', event.filter.sourceIp),
        ...getFilterAttribute('vrf', 'eq', event.filter.vrf),
      };
    }
    case 'vIgmpSnoopingGroup': {
      return {
        ...getFilterAttribute('groupIp', 'eq', event.filter.groupIp),
        ...getFilterAttribute('vlan', 'eq', event.filter.vlanNum),
      };
    }
    case 'vMplsForwarding': {
      return {
        ...getFilterAttribute('labelIn', 'eq', event.filter.label),
      };
    }
    case 'vAciEndpoint': {
      return {
        ...getFilterAttribute('bdVnid', 'eq', event.filter.bdVnid),
        ...getFilterAttribute('encapId', 'eq', event.filter.encapId),
        ...getFilterAttribute('ip', 'eq', event.filter.ip),
        ...getFilterAttribute('mac', 'eq', event.filter.mac),
      };
    }
    case 'vFabricPathRoutes': {
      return {
        ...getFilterAttribute('switchId', 'eq', event.filter.switchId),
        ...getFilterAttribute('subswitchId', 'eq', event.filter.subswitchId),
      };
    }
    case 'vLispLocal': {
      return {
        ...getFilterAttribute('eidPrefix', 'ip', event.filter.ip),
        ...getFilterAttribute('instanceId', 'eq', event.filter.instanceId),
      };
    }
    case 'vLispRemote': {
      return {
        ...getFilterAttribute('state', 'like', event.filter.state),
        ...getFilterAttribute('instanceId', 'eq', event.filter.instanceId),
      };
    }
    default:
      return undefined;
  }
};
